import type {
  SensitiveApprovalAuditDTO,
  SensitiveApprovalConfig,
  SensitiveApprovalConfigSaveDTO,
  SensitiveApprovalTicketDetail,
  SensitiveApprovalTicketPageData,
  SensitiveApprovalTicketQuery,
} from './types'
import { request } from '@/utils/service'

const PREFIX = 'teashop_merchant/merchant/sensitive-operation-approval'

export function getSensitiveApprovalTickets(params: SensitiveApprovalTicketQuery) {
  return request<IApiResponseData<SensitiveApprovalTicketPageData>>({
    url: `${PREFIX}/tickets`,
    method: 'GET',
    params,
  })
}

export function getSensitiveApprovalTicketDetail(ticketId: number) {
  return request<IApiResponseData<SensitiveApprovalTicketDetail>>({
    url: `${PREFIX}/tickets/${ticketId}`,
    method: 'GET',
  })
}

export function approveSensitiveApprovalTicket(ticketId: number, data?: SensitiveApprovalAuditDTO) {
  return request<IApiResponseData<void>>({
    url: `${PREFIX}/tickets/${ticketId}/approve`,
    method: 'POST',
    data: data ?? {},
  })
}

export function rejectSensitiveApprovalTicket(ticketId: number, data?: SensitiveApprovalAuditDTO) {
  return request<IApiResponseData<void>>({
    url: `${PREFIX}/tickets/${ticketId}/reject`,
    method: 'POST',
    data: data ?? {},
  })
}

export function cancelSensitiveApprovalTicket(ticketId: number) {
  return request<IApiResponseData<void>>({
    url: `${PREFIX}/tickets/${ticketId}/cancel`,
    method: 'POST',
  })
}

export function voidSensitiveApprovalTicket(ticketId: number, data?: SensitiveApprovalAuditDTO) {
  return request<IApiResponseData<void>>({
    url: `${PREFIX}/tickets/${ticketId}/void`,
    method: 'POST',
    data: data ?? {},
  })
}

export function getEffectiveSensitiveApprovalConfigs() {
  return request<IApiResponseData<SensitiveApprovalConfig[]>>({
    url: `${PREFIX}/config/effective`,
    method: 'GET',
  })
}

export function saveShopSensitiveApprovalConfig(data: SensitiveApprovalConfigSaveDTO) {
  return request<IApiResponseData<void>>({
    url: `${PREFIX}/config/shop`,
    method: 'PUT',
    data,
  })
}
